// extracted by mini-css-extract-plugin
module.exports = {"flex":"Container_flex__1BS2m","container":"Container_container__z_jSG","content":"Container_content__3Cymp"};